var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import OfficeEnvironment from '../../../../base/OfficeEnvironment';
//#region fix Office history behavior
// Thanks to https://stackoverflow.com/questions/42642863/office-js-nullifies-browser-history-functions-breaking-history-usage
var anyWindow = window;
function backupHistory() {
    // Office js deletes window.history.pushState and window.history.replaceState. Cache them and restore them
    anyWindow._historyCache = {
        replaceState: window.history.replaceState,
        pushState: window.history.pushState
    };
}
function restoreHistory() {
    // Office js deletes window.history.pushState and window.history.replaceState. Restore them
    window.history.replaceState = anyWindow._historyCache.replaceState;
    window.history.pushState = anyWindow._historyCache.pushState;
}
//#endregion
function loadOfficeJsApiFromCdn() {
    return new Promise(function (resolve, reject) {
        backupHistory();
        var script = document.createElement('script');
        script.onload = function () {
            // do stuff with the script
            var Office = window.Office;
            Office.initialize = function () {
                restoreHistory();
                resolve();
            };
        };
        script.onerror = reject;
        script.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
        // attach to the DOM
        document.body.appendChild(script);
    });
}
var OfficeApplicationSupportImplementation = function (_a) {
    var children = _a.children;
    var _b = __read(useState(!OfficeEnvironment.isRunningInsideOfficeApp), 2), isLoaded = _b[0], setIsLoaded = _b[1];
    useEffect(function () {
        if (isLoaded) {
            return;
        }
        loadOfficeJsApiFromCdn()
            .then(function () {
            setIsLoaded(true);
        })
            .catch(function (e) {
            // ToDo: handle error
            console.error(e);
        });
    }, []);
    if (!isLoaded) {
        return React.createElement("h1", null, "Loading Office...");
    }
    return children;
};
export default OfficeApplicationSupportImplementation;
//# sourceMappingURL=OfficeApplicationSupportImplementation.js.map